import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 新联会大屏总览缓存
    screenOverview: {}
  },
  mutations: {
    updateScreenOverview(state, data) {
      state.screenOverview = data || {};
    }
  },
  actions: {},
  modules: {},
  strict: process.env.NODE_ENV !== "production"
});
